import { render, staticRenderFns } from "./RelationGriffinMktzap.vue?vue&type=template&id=4367d8e0"
import script from "./RelationGriffinMktzap.vue?vue&type=script&lang=js"
export * from "./RelationGriffinMktzap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports